module.exports = __webpack_public_path__ + "img/agent.ecaa3bae.svg";